export const ConstantsUtil = {
    FIVE_MINUTES_IN_MS: 300_000
};
//# sourceMappingURL=ConstantsUtil.js.map